import AuthedPage from './AuthedPage';

export default AuthedPage;
